import { useState } from 'react';

const AIMSPortalPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddPortalPopup, setShowAddPortalPopup] =
      useState<boolean>(false);

    const addToggleHandler = () => {
      setShowAddPortalPopup(!showAddPortalPopup);
    };

    return (
      <Component
        showAddPortalPopup={showAddPortalPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default AIMSPortalPopupHOC;
